import { render, staticRenderFns } from "./questionWrapper.vue?vue&type=template&id=fb45d69a&scoped=true"
import script from "./questionWrapper.vue?vue&type=script&lang=js"
export * from "./questionWrapper.vue?vue&type=script&lang=js"
import style0 from "./questionWrapper.vue?vue&type=style&index=0&id=fb45d69a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb45d69a",
  null
  
)

export default component.exports